export function guessCountryCodeFromBbanLength(
  normalizedAccountNumber: string
): string | null {
  if (normalizedAccountNumber.length === 11) return `NO`;
  return null;
}
